/* =============================================================================
 * CCR Learn — behavioral instrumentation for the lead funnel. Captures signal
 * from BOTH converters and leavers so we can learn what earns a qualified lead
 * and where prospects drop. CSP-safe (external asset). Uses CCR.track (GTM ->
 * GA4); vendor pixels stay gated by consent in ccr-core/ccr-analytics.
 *   Events: faq_open, lead_qualify, section_view, form_abandon
 * ========================================================================== */
(function () {
  'use strict';
  var CCR = window.CCR || (window.CCR = {});
  function track(evt, payload) { if (CCR.track) CCR.track(evt, payload || {}); }

  /* FAQ opens = the live objection/intent map. `toggle` does not bubble, so we
     listen in the capture phase to catch every <details> on the page. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open) {
      var q = d.querySelector('summary');
      track('faq_open', { question: q ? q.textContent.trim().slice(0, 120) : '' });
    }
  }, true);

  /* Qualification choices — captures B2B intent (volume/interest/timeline) even
     from visitors who never submit the form. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-ccr-qualify]')) {
      track('lead_qualify', { field: el.getAttribute('data-ccr-qualify'), value: el.value });
    }
  });

  CCR.ready(function () {
    /* Section reach — how far down the funnel a prospect actually reads. */
    var sections = document.querySelectorAll('.wl-section, [data-ccr-view]');
    if ('IntersectionObserver' in window && sections.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var s = en.target;
          var h = s.querySelector('h1, h2');
          track('section_view', {
            section_index: s.getAttribute('data-ccr-index') || '',
            section_label: s.getAttribute('data-ccr-view') || (h ? h.textContent.trim().slice(0, 80) : '')
          });
          io.unobserve(s);
        });
      }, { threshold: 0.4 });
      sections.forEach(function (s, i) { s.setAttribute('data-ccr-index', i); io.observe(s); });
    }

    /* Form abandonment — started filling, left without submitting, and where. */
    document.querySelectorAll('form[data-ccr-form]').forEach(function (form) {
      var started = false, done = false, lastField = '';
      form.addEventListener('focusin', function (e) {
        started = true;
        var n = e.target && e.target.getAttribute && e.target.getAttribute('name');
        if (n) lastField = n;
      });
      form.addEventListener('submit', function () { done = true; });
      function flush() {
        if (started && !done) {
          done = true; /* fire once */
          track('form_abandon', { form_id: form.getAttribute('data-ccr-form'), last_field: lastField });
        }
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flush();
      });
      window.addEventListener('pagehide', flush);
    });
  });
})();
